// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ShipPickerController from "./ship_picker_controller"
application.register("ship-picker", ShipPickerController)

import SimulationController from "./simulation_controller"
application.register("simulation", SimulationController)
